module.exports = __webpack_public_path__ + "img/logo-1-light.9be3f2a7.png";